import { RootState } from 'store';

export const selectOLDialog = (state: RootState) => state.optimisticLocking;
